import { Link } from "react-router-dom";
import { Clock } from "lucide-react";
import { CATEGORY_STYLES, CATEGORY_LABELS } from "@/lib/api";

export default function ArticleCard({ article, index = 0 }) {
  return (
    <Link
      to={`/blog/${article.slug}`}
      data-testid={`article-card-${article.slug}`}
      className="group block animate-fade-up"
      style={{ animationDelay: `${index * 0.08}s` }}
    >
      <div className="overflow-hidden rounded-[2rem] aspect-[4/3] mb-6">
        <img
          src={article.image}
          alt={article.title}
          className="h-full w-full object-cover transition-transform duration-700 ease-out group-hover:scale-105"
        />
      </div>
      <span
        className={`inline-block rounded-full px-3 py-1 text-xs font-sans font-medium uppercase tracking-wider ${
          CATEGORY_STYLES[article.category] || CATEGORY_STYLES["small-pets"]
        }`}
      >
        {CATEGORY_LABELS[article.category] || article.category}
      </span>
      <h3 className="font-serif text-2xl sm:text-3xl text-[#2C3529] mt-4 mb-2 leading-snug group-hover:text-[#D96B43] transition-colors">
        {article.title}
      </h3>
      <p className="font-sans text-[#576054] leading-relaxed line-clamp-2">
        {article.excerpt}
      </p>
      <div className="flex items-center gap-3 mt-4 text-sm font-sans text-[#8a9184]">
        <span>{article.author}</span>
        <span className="h-1 w-1 rounded-full bg-[#c2c7ba]" />
        <span className="flex items-center gap-1">
          <Clock size={14} strokeWidth={1.5} /> {article.read_time} min read
        </span>
      </div>
    </Link>
  );
}
